var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"md":"8","offset-md":"2"}},[_c('v-container',{staticClass:"page page--form"},[_c('bills-item-form',{attrs:{"source":_vm.$route.params.source}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }